var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2022 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useParams } from "react-router-dom";
import "./index.css";
import App from "./App";
import "./services/i18n";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import { theme } from "@sequentech/ui-essentials";
import AuthContextProvider from "./providers/AuthContextProvider";
import { SettingsContext, SettingsWrapper } from "./providers/SettingsContextProvider";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { WasmWrapper } from "./providers/WasmWrapper";
var root = ReactDOM.createRoot(document.getElementById("root"));
export var TenantEventContext = React.createContext({
    tenantId: null,
    eventId: null,
});
// This component will be used to provide tenantId and eventId to the context
export var TenantEventProvider = function (_a) {
    var tenantId = _a.tenantId, eventId = _a.eventId, children = _a.children;
    console.log("TenantEventProvider: tenantId=".concat(tenantId, ", eventId=").concat(eventId));
    return (_jsx(TenantEventContext.Provider, __assign({ value: { tenantId: tenantId, eventId: eventId } }, { children: children })));
};
var KeycloakProvider = function (_a) {
    var disable = _a.disable, children = _a.children;
    var _b = useContext(TenantEventContext), tenantId = _b.tenantId, eventId = _b.eventId;
    console.log("KeycloakProvider: tenantId=".concat(tenantId, ", eventId=").concat(eventId));
    return disable ? (_jsx(_Fragment, { children: children })) : (_jsx(AuthContextProvider, { children: _jsx(_Fragment, { children: children }) }));
};
export var RouteParameterProvider = function (_a) {
    var children = _a.children;
    var _b = useParams(), tenantId = _b.tenantId, eventId = _b.eventId;
    console.log("RouteParameterProvider: tenantId=".concat(tenantId, ", eventId=").concat(eventId));
    return (_jsx(TenantEventProvider, __assign({ tenantId: tenantId ? tenantId : null, eventId: eventId ? eventId : null }, { children: children })));
};
export var KeycloakProviderContainer = function (_a) {
    var children = _a.children;
    var globalSettings = useContext(SettingsContext).globalSettings;
    return _jsx(KeycloakProvider, __assign({ disable: globalSettings.DISABLE_AUTH }, { children: children }));
};
root.render(_jsx(React.StrictMode, { children: _jsx(WasmWrapper, { children: _jsx(SettingsWrapper, { children: _jsx(KeycloakProviderContainer, { children: _jsx(Provider, __assign({ store: store }, { children: _jsx(BrowserRouter, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(App, {}) })) }) })) }) }) }) }));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
